module.exports = __webpack_public_path__ + "4764fafc6cffbd4383c536b0ed2065f2.png";